import { render, staticRenderFns } from "./PublicShoppingList.vue?vue&type=template&id=5b50018d"
import script from "./PublicShoppingList.vue?vue&type=script&lang=js"
export * from "./PublicShoppingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports